import { SHAPE_STYLES } from './constants';
import { createAndAddLocalContainer, setContainerStyle } from './container';
import logger from './controllers/logger';
import { getZeroStaticEntity, setEntityPosition, setParent } from './entity';
import { v2 } from './helpers';
import {
  EMPTY_RENDER_TRANSFORM,
  type RenderPackageItem,
  type RenderPackageRect,
} from './render_package';
import { ObjectType } from './shared/api_shared_types';
import { setVisibilityState } from './simulate';
import {
  Entity,
  GameManager,
  Shape,
  SharedObjectType,
  GameObjectController,
  type Space,
  type GameObject,
  VisibilityState,
  type V2,
  RenderItemType,
} from './types';

export function controller(): GameObjectController {
  return {
    getNew: getZeroSpace,
    sync: null,
    update: updateSpace,
    // createView: null,
    createPackage,
  };
}

export function getZeroSpace(ent: Entity): Space {
  let newSpace: Space = {
    ...ent,
    objectType: SharedObjectType.SPACE,
    resizedThisFrame: false,
    rooms: null,
    debug: null,
    cursor: null,
    requestResize: false,
    resizeApplied: false,
    lastWindowResizedTime: 0,
    shape: Shape.RECT,
    addRoom,
  };

  return newSpace;
}

export function initSpace(manager: GameManager, ent: Entity): Space {
  const space = getZeroSpace(ent);
  space.manager = manager;
  // space.childAnchorPivot = v2();
  space.requestResize = true;
  setVisibilityState(space, VisibilityState.DEFAULT);

  {
    const c = createAndAddLocalContainer(manager, getZeroStaticEntity());
    c.pivotPoint = v2();
    // c.childAnchorPivot = v2();
    c.relativeWidth = 1;
    c.relativeHeight = 1;
    c.fixedZIndex = true;
    setContainerStyle(c, null);
    setParent(c, space, v2());
    setVisibilityState(c, VisibilityState.DEFAULT);
    
    space.rooms = c;
    space.anchoredPos.relativePivotPos = v2(0, 0);
  }

  return space;
}

function updateSpace(obj: Space): boolean {
  if (obj.requestResize) {
    obj.requestResize = false;

    obj.width = Math.max(window.innerWidth, 300);
    obj.height = Math.max(window.innerHeight, 300);
    obj.layoutChanged = true;
    obj.resizedThisFrame = true;

    return true;
  }

  return false;
}

function addRoom(child: GameObject, space: Space) {
  if (child.objectType === ObjectType.ROOM) {
    setParent(child, space.rooms, v2());
  } else {
    console.error('you can only parent rooms to window');
  }
}

export function createPackage(space: Space, position: V2, scale: number): RenderPackageItem[] {
  const rPackage: RenderPackageItem[] = [];

  if (false) {
    let rect: RenderPackageRect = {
      type: RenderItemType.rect,
      ...EMPTY_RENDER_TRANSFORM,
      positionX: position.x,
      positionY: position.y,
      scale,
      width: space.width,
      height: space.height,
      shapeStyle: SHAPE_STYLES.DEBUG,
      cornerRadius1: 20,
      cornerRadius2: 20,
      cornerRadius3: 20,
      cornerRadius4: 20,
      shadow: null,
    };
    rPackage.push(rect);
  }

  return rPackage;
}
